module.exports = __webpack_public_path__ + "assets/img/63@3x.d71f177c.png";